import { SentimentTab } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sentiment-report/topics-graph/types";

export const MAX_PROMPTS_PER_SENTIMENT = 50;
export const DEFAULT_TAB = SentimentTab.Positive;
